<div class="modal-header">
</div>
<div class="modal-body">
  <div [innerHTML]="message" class="body-message"></div>
</div>
<div class="modal-footer">
  <ng-container *ngIf="options.length">
    <button *ngFor="let option of options" type="button" class="btn btn-default btn-respond" (click)="respond(option)">{{option}}</button>
  </ng-container>
</div>
  